import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MasterLayoutRoutingModule } from './master-layout-routing.module';
import { ServicesModule } from '../services/services.module';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { LeftSideMenuComponent } from './left-side-menu/left-side-menu.component';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { HeaderComponent } from './header/header.component';
import { BreadcrumbModule } from 'angular-crumbs';
import { MatSelectModule } from '@angular/material/select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  providers: [
    // {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}}
  ],
  declarations: [
    LeftSideMenuComponent,
    HeaderComponent
  ],
  imports: [
    CommonModule,
    MasterLayoutRoutingModule,
    SharedModule,
    ServicesModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    PerfectScrollbarModule,
    MatMenuModule,
    MatTooltipModule,
    FeatherModule,
    BreadcrumbModule,
    FeatherModule.pick(allIcons),
    MatSelectModule,
    InfiniteScrollModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MasterLayoutModule { }
